import {Injectable} from '@angular/core';
import {PaymentRequestRepository} from './ngrx/PaymentRequest.repository';
import {PaymentRequestModel} from '../../api/entity/paymentRequest.model';
import {AbstractFindOneByIdService} from '../../../../../core/service/v2/service/findone/abstractFindOneById.service';
import {PaymentRequestDataServiceAdapter} from './ngrx/PaymentRequestDataService.adapter';

@Injectable()
export class PaymentRequestFindOneByIdService extends AbstractFindOneByIdService<PaymentRequestModel, PaymentRequestModel> {

    constructor(repository: PaymentRequestRepository, dataServiceAdapter: PaymentRequestDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
